<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params" :rules="rules">
        <el-col :span="7" :xs="24">
          <!-- <el-date-picker
              v-model="time"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="timestamp"/> -->
          <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
        </el-col>
        <el-col :span="5" :xs="12">
          <el-form-item prop="socketNum">
            <el-input
              v-model.number="params.socketNum"
              placeholder="输入电站端口号查询"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table :data="records" stripe>
      <el-table-column fixed label="电站编号" prop="chargingPileIds" />
      <el-table-column label="插座号" prop="socketNum" />
      <el-table-column label="开始时间" min-width="100">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? "未开始"
              : timeFormat(scope.row.startTime)
          }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" min-width="100">
        <template #default="scope">
          {{
            scope.row.state === "2" ? "充电中" : timeFormat(scope.row.endTime)
          }}
        </template>
      </el-table-column>
      <el-table-column label="充电时长">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? scope.row.startTime
              : differTime(scope.row.startTime, scope.row.endTime)
          }}分钟
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="money" />
      <el-table-column label="度数">
        <template #default="scope">
          {{
            new BigNumber(scope.row.powerConsumption).plus(
              new BigNumber(scope.row.powerConsumptionStop || 0)
            )
          }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template #default="scope">
          <span v-if="scope.row.state === '1'"> 等待连接 </span>
          <span v-else-if="scope.row.state === '2'"> 充电中 </span>
          <span v-else-if="scope.row.state === '3'"> 暂停 </span>
          <span v-else-if="scope.row.state === '4'"> 完成 </span>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
  </div>
</template>

<script>
import agentGetOrderListByWhere from "@/api/fund/order-manage/agentGetOrderListByWhere";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import BigNumber from "bignumber.js";

export default {
  name: "UserManageDetailOne",
  components: { Page },
  mixins: [createdMixin, pageMixin, searchMixin, timeMixin],
  data() {
    return {
      BigNumber,
      rules: {
        socketNum: [{ type: "number", message: "插座号必须为数字值" }],
      },
      time: [],
      records: [],
      params: {
        memberId: this.$route.params.id,
        socketNum: undefined,
        sortName: "id",
        sortType: "DESC",
      },
    };
  },
  methods: {
    fetchData() {
      agentGetOrderListByWhere(this.params, this.current).then((res) => {
        this.total = res.total;
        this.records = res.records;
      });
    },
  },
};
</script>
